import {
  CompanyContainer,
  CompanyContentContainer,
  CompanyTabsContent,
  CompanyTabsList,
} from "components/company/v3/CompanyContainers";
import { CompanyAssetsTabEnum } from "components/company/v3/menu/enums";
import FiisAssetsContent from "components/company/v3/realestatefunds/contents/assets/FiisAssetsContent";
import FiisDistributionOfAssetsContent from "components/company/v3/realestatefunds/contents/assets/FiisDistributionOfAssetsContent";
import classNames from "components/ui/classNames";
import { Tabs } from "components/ui/Tabs";
import { HomeIcon, PercentIcon } from "lucide-react";
import { useIntl } from "react-intl";

interface FiisAssetsBoxProps {
  isRenderPageDefault?: boolean;
  tab: CompanyAssetsTabEnum;
  onChangeTab: (tab: CompanyAssetsTabEnum) => void;
}

export default function FiisAssetsBox({ isRenderPageDefault = false, tab, onChangeTab }: FiisAssetsBoxProps) {
  const intl = useIntl();

  return (
    <CompanyContainer
      className={classNames({
        "xl:max-h-[526px]": tab === CompanyAssetsTabEnum.DISTRIBUTION,
        "xl:h-fit xl:max-h-[min(calc(100dvh-193px),_768px)]": tab === CompanyAssetsTabEnum.QUOTA,
      })}
    >
      <CompanyContentContainer>
        <Tabs
          defaultValue={CompanyAssetsTabEnum.DISTRIBUTION}
          value={tab}
          onValueChange={(value) => onChangeTab(value as CompanyAssetsTabEnum)}
          className="h-full w-full"
        >
          <CompanyTabsList
            tabs={[
              {
                value: CompanyAssetsTabEnum.DISTRIBUTION,
                label: intl.formatMessage({
                  defaultMessage: "Distribuição",
                  description: "Aba do menu superior da empresa",
                  id: "cXmS8k",
                }),
                icon: <PercentIcon className="inline-flex" size={16} strokeWidth={2} />,
              },
              {
                value: CompanyAssetsTabEnum.QUOTA,
                label: intl.formatMessage({
                  defaultMessage: "Imóveis",
                  description: "Aba do menu superior da empresa",
                  id: "2Jq2AR",
                }),
                icon: <HomeIcon className="inline-flex" size={16} strokeWidth={2} />,
              },
            ]}
          />

          <CompanyTabsContent value={CompanyAssetsTabEnum.DISTRIBUTION}>
            <FiisDistributionOfAssetsContent />
          </CompanyTabsContent>

          <CompanyTabsContent value={CompanyAssetsTabEnum.QUOTA}>
            <FiisAssetsContent isRenderPageDefault={isRenderPageDefault} />
          </CompanyTabsContent>
        </Tabs>
      </CompanyContentContainer>
    </CompanyContainer>
  );
}
